module.exports = __webpack_public_path__ + "static/img/baseball.8b64e14.jpg";